import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import "./Login.scss";
import { useLogin } from "../../hooks/useLogin";
import Button from "../../components/Button/Button";
import { useForm, useFormState } from "react-hook-form";
import getClasses from "../../utils/getClasses";
import FormInput from "../../components/Forms/FormInput/FormInput";
import logo from "../../assets/icons/logo-home.svg";


interface LoginPageForm {
  email: string;
  password: string;
}

const Login: FC = () => {
  const { fetchLogin } = useLogin();
  const { t } = useTranslation();
  const { register, handleSubmit, control } = useForm<LoginPageForm>({
    mode: "all",
  });
  const formState = useFormState({
    control,
  });
  const onSubmit = (data: LoginPageForm) => {
    fetchLogin({ email: data.email, password: data.password });
  };

  return (
    <>
      <div className="sidebar-wrapper">
        <img
          src={logo}
          alt="SMARTBEAT"
        />
      </div>
      <h2 className="title">{t("login.title")}</h2>
      <form className="form-container">
        <div className="form-content">
          <div
            className={`form-group ${
              formState.errors.hasOwnProperty("email") ? "is-invalid" : ""
            }`}
          >
            <FormInput
              type="email"
              wrapperClass="col-lg-12"
              isInvalid={formState.errors.hasOwnProperty("email")}
              label={t("login.labelEmail")}
              placeholder={t("login.placeholderEmail")}
              typeErrors={formState.errors.email?.message as string}
              register={register("email", {
                required: {
                  value: true,
                  message: t("form-generic.error.required"),
                },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: t("form-generic.error.email"),
                },
              })}
            />
          </div>
          <div
            className={`form-group ${getClasses({
              "is-invalid": formState.errors.hasOwnProperty("password"),
            })}`}
          >
            <label className="form-control-label"></label>
            <FormInput
              type="password"
              wrapperClass="col-lg-12"
              isInvalid={formState.errors.hasOwnProperty("password")}
              label={t("login.labelPassword")}
              placeholder={t("login.placeholderPassword")}
              register={register("password", {
                required: {
                  value: true,
                  message: t("form-generic.error.required"),
                },
              })}
            />
          </div>
        </div>
        <div className="action">
          <Button onClick={handleSubmit(onSubmit)} btnType="submit" fullWidth>
            {t("login.buttonSubmit")}
          </Button>
          <div className="recovery"></div>
        </div>
      </form>
    </>
  );
};

export default Login;
